<script setup lang="ts">
import { toTwoDecimalNumbers } from '@/utils/number';
import { computed } from 'vue';

const props = defineProps({
    formFactor: {
        type: String,
        default: 'label'
    },
    currentUploadSizeMb: {
        type: Number,
        default: 0
    },
    maxUploadSizeMb: {
        type: Number,
        default: 0
    },
    showProgressAsPercentage: {
        type: Boolean,
        default: false
    },
    progressBarHeight: {
        type: Number,
        default: 5
    },
    progressBarColor: {
        type: String,
        default: 'primary'
    }
});

const progressValue = computed(() => {
    if (!props.showProgressAsPercentage) return props.currentUploadSizeMb;
    if (!props.maxUploadSizeMb) return 0;
    return (props.currentUploadSizeMb / props.maxUploadSizeMb) * 100;
});

const progressMax = computed(() => {
    if (!props.showProgressAsPercentage) return props.maxUploadSizeMb;
    return 100;
});
</script>

<template>
    <template v-if="formFactor === 'label'">
        <label> Opslag: {{ toTwoDecimalNumbers(currentUploadSizeMb) }} MB / {{ maxUploadSizeMb }} MB </label>
        <v-progress-linear :model-value="progressValue" :max="progressMax" :height="progressBarHeight" :color="progressBarColor" class="mb-2" />
    </template>
    <template v-else-if="formFactor === 'span'">
        <span class="text-subtitle-2 font-weight-regular">
            Opslag: {{ toTwoDecimalNumbers(currentUploadSizeMb) }} MB / {{ maxUploadSizeMb }} MB
        </span>
        <v-progress-linear :model-value="progressValue" :max="progressMax" :height="progressBarHeight" :color="progressBarColor" />
    </template>
</template>
